////////////////////////////////
//         INTERFACE          //
////////////////////////////////

/**
 * Interface that manages display and color categories
 */
export interface FhirCategory {
  code: string;
  displayKey: string;
  abbreviation : string;
  color: string;
  className: string
}

////////////////////////////////
//         CONSTANTS          //
////////////////////////////////

/**
* All category with color 
*/
export const scheduleCategory: FhirCategory[] = [
  { code: "VACATION", displayKey: "scheduleCategory.Congé", abbreviation :"A" , color: '#B5EAD7', className :"item-vacation"},
  { code: "PRESENT", displayKey: "scheduleCategory.Présentiel", abbreviation :"P", color: '#C7CEEA', className :"item-present"},
  { code: "REMOTE", displayKey: "scheduleCategory.Télétravail", abbreviation :"TLT", color:'#FFDAC1', className :"item-remote"},
  { code: "TRAINING", displayKey: "scheduleCategory.Formation", abbreviation :"F", color: '#FF9AA2', className :"item-training"},
  { code: "SICK", displayKey: "scheduleCategory.Maladie", abbreviation :"M", color: '#FFF5BA', className :"item-sick" },
  { code: "LEAVE", displayKey: "scheduleCategory.RTT", abbreviation :"RTT", color: '#E2F0CB', className :"item-leave" },
  { code: "NULL", displayKey: "scheduleCategory.Vide", abbreviation :"", color: '#ece9d8', className :"item-unknown" },
]
